"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogContentText = _interopRequireDefault(require("@material-ui/core/DialogContentText"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Transition = _interopRequireDefault(require("../Transition"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Confirmation =
/*#__PURE__*/
function (_Component) {
  _inherits(Confirmation, _Component);

  function Confirmation(props) {
    var _this;

    _classCallCheck(this, Confirmation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Confirmation).call(this, props));
    _this.state = {
      showDialog: false,
      currentFunction: null,
      userInput: '',
      error: false
    };
    _this.closeDialog = _this.closeDialog.bind(_assertThisInitialized(_this));
    _this.handleCancel = _this.handleCancel.bind(_assertThisInitialized(_this));
    _this.handleConfirmation = _this.handleConfirmation.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Confirmation, [{
    key: "dialog",
    value: function dialog() {
      var showDialog = this.state.showDialog;
      var _this$props = this.props,
          confirmationTitle = _this$props.confirmationTitle,
          cancelTitle = _this$props.cancelTitle;
      var _this$props2 = this.props,
          question = _this$props2.question,
          title = _this$props2.title;

      if (title == null) {
        title = question;
        question = null;
      }

      return showDialog && _react["default"].createElement(_Dialog["default"], {
        open: true,
        onClose: this.closeDialog,
        TransitionComponent: _Transition["default"]
      }, title && _react["default"].createElement(_DialogTitle["default"], null, title), question && _react["default"].createElement(_DialogContent["default"], null, _react["default"].createElement(_DialogContentText["default"], {
        id: "alert-dialog-slide-description"
      }, question)), this.levelPresentation(), _react["default"].createElement(_DialogActions["default"], null, _react["default"].createElement(_Button["default"], {
        onClick: this.handleCancel,
        color: "secondary"
      }, cancelTitle), _react["default"].createElement(_Button["default"], {
        autoFocus: true,
        onClick: this.handleConfirmation,
        variant: "contained",
        color: "primary"
      }, confirmationTitle)));
    }
  }, {
    key: "levelPresentation",
    value: function levelPresentation() {
      var _this2 = this;

      var _this$props3 = this.props,
          level = _this$props3.level,
          confirmationTitle = _this$props3.confirmationTitle;
      var _this$state = this.state,
          userInput = _this$state.userInput,
          error = _this$state.error;
      return level === 'hard' && _react["default"].createElement(_DialogContent["default"], null, _react["default"].createElement("div", {
        style: {
          paddingTop: 5
        }
      }, _react["default"].createElement(_TextField["default"], {
        error: error,
        variant: "outlined",
        defaultValue: userInput,
        label: "Type ".concat(confirmationTitle),
        onChange: function onChange(e) {
          _this2.setState({
            userInput: e.target.value
          });
        }
      })));
    }
  }, {
    key: "interceptChildren",
    value: function interceptChildren() {
      var _this3 = this;

      var children = this.props.children;
      var intercept = this.props.intercept;

      if (typeof intercept === 'string') {
        intercept = [intercept];
      }

      return _react["default"].Children.map(children, function (child) {
        var interceptions = intercept.reduce(function (result, func) {
          if (child.props[func]) {
            var some = function some() {
              _this3.setState({
                currentFunction: child.props[func],
                showDialog: true
              });
            };

            result[func] = some;
          }

          return result;
        }, []);
        return _react["default"].cloneElement(child, _objectSpread({}, interceptions));
      });
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.closeDialog();
    }
  }, {
    key: "closeDialog",
    value: function closeDialog() {
      this.setState({
        showDialog: false,
        currentFunction: null
      });
    }
  }, {
    key: "validateLevel",
    value: function validateLevel() {
      var userInput = this.state.userInput;
      var _this$props4 = this.props,
          confirmationTitle = _this$props4.confirmationTitle,
          level = _this$props4.level;

      if (level === 'hard') {
        return userInput.toLowerCase() === confirmationTitle.toLowerCase();
      }

      return true;
    }
  }, {
    key: "handleConfirmation",
    value: function handleConfirmation() {
      if (this.validateLevel()) {
        var currentFunction = this.state.currentFunction;
        this.closeDialog();
        currentFunction();
      } else {
        this.setState({
          error: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement(_react["default"].Fragment, null, this.interceptChildren(), this.dialog());
    }
  }]);

  return Confirmation;
}(_react.Component);

Confirmation.propTypes = {
  /**
   * String for the cancel button label
   */
  cancelTitle: _propTypes["default"].string,

  /**
   * Elements to intercept
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * String for the confirmation button label
   */
  confirmationTitle: _propTypes["default"].string,

  /**
   * String for the question in the dialog content area
   */
  question: _propTypes["default"].string.isRequired,

  /**
   * function list to intercept. You can pass [String] or String
   */
  intercept: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),

  /**
   * Level for confirm. Hard will ask the user to type the confirmationTitle
   */
  level: _propTypes["default"].oneOf(['normal', 'hard']),

  /**
   * optional title to use as dialog title
   */
  title: _propTypes["default"].string
};
Confirmation.defaultProps = {
  cancelTitle: 'Abbrechen',
  confirmationTitle: 'Ok',
  intercept: 'onClick',
  level: 'normal',
  title: ''
};
var _default = Confirmation;
exports["default"] = _default;